import {
  AppointmentEvent,
  BasketUpdatedEvent,
  BundleQuoteFragment,
  ControlDeniedEvent,
  ControlGivenEvent,
  ControlRequestedEvent,
  HeartbeatEvent,
  ParticipantJoinedAppointmentEvent,
  ParticipantLeftAppointmentEvent,
  ProductType,
  Quote,
  StateChangedEvent,
} from '@generated/gql/graphql';
import { BroadbandQuote } from '@src/types/broadband';
import { EnergyQuote } from '@src/types/bundle';

const isEnergyQuote = (quote: Quote): quote is EnergyQuote => {
  return quote.product.type === ProductType.Energy;
};

const isBroadbandQuote = (
  quote: Quote | BundleQuoteFragment
): quote is BroadbandQuote => quote.product.type === ProductType.Broadband;

const isControlDeniedEvent = (
  event: AppointmentEvent
): event is ControlDeniedEvent => event.__typename === 'ControlDeniedEvent';

const isControlRequestedEvent = (
  event: AppointmentEvent
): event is ControlRequestedEvent =>
  event.__typename === 'ControlRequestedEvent';

const isControlGivenEvent = (
  event: AppointmentEvent
): event is ControlGivenEvent => event.__typename === 'ControlGivenEvent';

const isParticipantJoinedAppointmentEvent = (
  event: AppointmentEvent
): event is ParticipantJoinedAppointmentEvent =>
  event.__typename === 'ParticipantJoinedAppointmentEvent';

const isParticipantLeftAppointmentEvent = (
  event: AppointmentEvent
): event is ParticipantLeftAppointmentEvent =>
  event.__typename === 'ParticipantLeftAppointmentEvent';

const isBasketUpdatedEvent = (
  event: AppointmentEvent
): event is BasketUpdatedEvent => event.__typename === 'BasketUpdatedEvent';

const isHeartbeatEvent = (event: AppointmentEvent): event is HeartbeatEvent =>
  event.__typename === 'HeartbeatEvent';

const isStateChangedEvent = (
  event: AppointmentEvent
): event is StateChangedEvent => event.__typename === 'StateChangedEvent';

const isObject = (input: unknown): input is Record<string, unknown> => {
  return typeof input === 'object' && input !== null && !Array.isArray(input);
};

export {
  isEnergyQuote,
  isBroadbandQuote,
  isControlDeniedEvent,
  isControlRequestedEvent,
  isControlGivenEvent,
  isParticipantJoinedAppointmentEvent,
  isParticipantLeftAppointmentEvent,
  isBasketUpdatedEvent,
  isHeartbeatEvent,
  isStateChangedEvent,
  isObject,
};
